import { render, staticRenderFns } from "./GiftBasketForm.vue?vue&type=template&id=6065fc3c&"
import script from "./GiftBasketForm.vue?vue&type=script&lang=js&"
export * from "./GiftBasketForm.vue?vue&type=script&lang=js&"
import style0 from "./GiftBasketForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports